<template>
  <teleport to="#navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <RouterLink to="/" v-slot="{ href, navigate, isExactActive }" custom>
        <li class="nav-item" :class="{ active: isExactActive }">
          <a class="nav-link" :href="href" @click="navigate">Meine Schichten</a>
        </li>
      </RouterLink>
      <RouterLink to="/shifts" v-slot="{ href, navigate, isActive }" custom>
        <li class="nav-item" :class="{ active: isActive }">
          <a class="nav-link" :href="href" @click="navigate">Schichten</a>
        </li>
      </RouterLink>
      <RouterLink
        to="/user/me"
        v-slot="{ href, navigate, isExactActive }"
        custom
      >
        <li class="nav-item" :class="{ active: isExactActive }">
          <a class="nav-link" :href="href" @click="navigate">Profil</a>
        </li>
      </RouterLink>
    </ul>
    <ul class="navbar-nav">
      <RouterLink
        to="/teams"
        v-if="isTeamlead"
        v-slot="{ href, navigate, isActive }"
        custom
      >
        <li class="nav-item" :class="{ active: isActive }">
          <a class="nav-link" :href="href" @click="navigate"
            >Teams bearbeiten</a
          >
        </li>
      </RouterLink>
      <RouterLink
        to="/user"
        v-if="isTeamlead"
        v-slot="{ href, navigate, isActive }"
        custom
      >
        <li class="nav-item" :class="{ active: isActive }">
          <a class="nav-link" :href="href" @click="navigate">Crew</a>
        </li>
      </RouterLink>
      <RouterLink
        to="/reception"
        v-if="isReception && ticketing_enabled"
        v-slot="{ href, navigate, isActive }"
        custom
      >
        <li class="nav-item" :class="{ active: isActive }">
          <a class="nav-link" :href="href" @click="navigate">Rezeption</a>
        </li>
      </RouterLink>
      <RouterLink
        to="/events"
        v-if="isAdmin"
        v-slot="{ href, navigate, isActive }"
        custom
      >
        <li class="nav-item" :class="{ active: isActive }">
          <a class="nav-link" :href="href" @click="navigate">Veranstaltungen</a>
        </li>
      </RouterLink>

      <li class="nav-item dropdown" v-if="isAdmin">
        <a
          href="#"
          class="nav-link dropdown-toggle"
          id="reportsDropdownLink"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
          >Berichte <span class="caret"></span
        ></a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="reportsDropdownLink"
        >
          <RouterLink class="dropdown-item" to="/reports/phones"
            >Telefonliste</RouterLink
          >
          <RouterLink
            class="dropdown-item"
            to="/reports/shirts"
            v-if="!hide_tshirts"
            >Shirt Größen</RouterLink
          >
        </div>
      </li>
      <li class="nav-item dropdown" v-if="isAdmin">
        <a
          href="#"
          class="nav-link dropdown-toggle"
          id="settingsDropdownLink"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
          ><span class="fa fa-gear"></span> <span class="caret"></span
        ></a>
        <div class="dropdown-menu dropdown-menu-right">
          <RouterLink class="dropdown-item" to="/settings/config"
            >Konfiguration</RouterLink
          >
          <RouterLink class="dropdown-item" to="/settings/apikey"
            >API</RouterLink
          >
          <RouterLink class="dropdown-item" to="/settings/webhook"
            >Webhooks</RouterLink
          >
        </div>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" @click="logout()" v-if="isLoggedin"
          >Logout</a
        >
      </li>
    </ul>
  </teleport>
  <div
    v-if="isLoggedin && !user.email_confirmed"
    class="alert alert-danger"
    role="alert"
  >
    Du hast deine E-Mail-Adresse noch nicht bestätigt. Wenn du dein Passwort
    vergessen hast, kannst du es nicht wiederherstellen!<br />
    Schaue in deinem Mailpostfach nach!<br />
    <button
      class="btn-light btn"
      @click="resendEmail()"
      :disabled="!buttonEnabled"
    >
      E-Mail neu senden
    </button>
  </div>
  <RouterView></RouterView>
  <slot></slot>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useUserStore } from "../stores/user";
import router from "../router";
import userService from "../services/user.service";
import { useAlertsStore } from "../stores/alerts.js";
import { useConfigStore } from "../stores/config";
import * as Sentry from '@sentry/vue';

export default {
  name: "ToolLayout",
  data() {
    return {
      buttonEnabled: true,
    };
  },
  async beforeRouteEnter() {
    await useUserStore().getMe();
    await useConfigStore().get();
  },
  computed: {
    ...mapState(useUserStore, [
      "user",
      "isLoggedin",
      "isTeamlead",
      "isReception",
      "isAdmin",
    ]),
    ...mapState(useConfigStore, [
      "guests_enabled",
      "ticketing_enabled",
      "dietary_enabled",
      "hide_tshirts",
    ]),
  },
  methods: {
    ...mapActions(useUserStore, { userLogout: "logout" }),
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async logout() {
      try {
        await this.userLogout();
        this.addAlert("success", "Du bist nun ausgeloggt, bis bald!");
        router.push("/login");
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    async resendEmail() {
      this.buttonEnabled = false;
      try {
        await userService.resendEmail();
        this.addAlert(
          "success",
          "Alles klar, klick auf die E-Mail und lade die Seite danach neu!"
        );
        // enable button after 60s..
        setTimeout(() => {
          this.buttonEnabled = true;
        }, 60 * 1000);
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.buttonEnabled = true;
      }
    },
  },
};
</script>

<style scoped></style>
